import axios from "axios";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { Spinner } from "react-bootstrap";

const FUCSChange = ({ fcus, po }) => {
  const [showSave, setShowSave] = useState(false);
  const [newFcus, setNewFcus] = useState(fcus || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewFcus((fcus || "").trim().toUpperCase());
  }, [fcus]);

  const handleInputChange = (e) => {
    setNewFcus(e.target.value.trim().toUpperCase());
  };

  const handleEdit = () => {
    setShowSave(true);
  }

  const handleSubmit = async() => {

    const result = await Swal.fire({
        title: 'Are you sure?',
        // icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: "custom-swal-popup", 
          confirmButton: "custom-confirm-button", 
          cancelButton: "custom-cancel-button", 
        },
      });
      if(result.isConfirmed){
        setLoading(true);
        try{
            const response = await axios.post(`/admin/changeFcus`,
                {
                    PO: po,    
                    newFcus: newFcus    
                }
            )
            console.log('response check', response)
            setNewFcus(newFcus);
            Swal.fire('Success!', 'new fcus updated.', 'success');
        }
        catch (error) {
            setNewFcus(fcus);
            console.error('error:', error);          
            const errorMessage = error?.response?.data?.message || "Something went wrong";
            Swal.fire('Error', errorMessage, 'error');
          }
        finally{
            setShowSave(false);
            setLoading(false);
        }
      }

  };

  return (
    <td>
      <div className="d-flex align-items-center gap-2">
        <input
          type="text"
          value={newFcus}
          disabled= {!showSave}
          onChange={(e) => handleInputChange(e)}
          className="form-control form-control-sm"
          style={{ width: "65px" }}
          maxLength={7}
        />
        <button
          onClick={showSave === false ? handleEdit : handleSubmit}
          className={
            showSave === false
              ? "btn btn-sm btn-primary"
              : "btn btn-sm btn-success"
          }
          style={{ width: "43px" }}
          disabled = {loading}
        >
          {showSave === false ? ("Edit" ): (loading ? <Spinner size="sm"/> : "Save")}
        </button>
      </div>
    </td>
  );
};
export default FUCSChange;
